<template>
    <div v-show="items.length > 0">
        <table class="table">
            <thead>
                <tr>
                    <th style="width: 10%;">{{ t('Shop') }}</th>
                    <th style="width: 20%;">{{ t('Seller') }}</th>
                    <th style="width: 30%;">{{ t('Name') }}</th>
                    <th>{{ t('Count of occurs as price leader') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in items">
                    <td>{{ item.shop_name }}</td>
                    <td>
                        <span v-show="item.seller_name">{{ item.seller_name }}</span>
                    </td>
                    <td>
                        <a :href="item.link" target="_blank" rel="noreferrer">{{item.name}}</a>
                    </td>
                    <td>{{ item.price_leader_count }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    export default
    {
        props: {
            title:
            {
                type: String,
                default: () => {
                    return '';
                }
            },
            id: {
            },
            url: {
                type: String
            },
            items: {
                type: Array,
                required: false
            },
        },
        data()
        {
            return {
            };
        },
        mounted()
        {
            if (this.id) {
                this.load();
            }
        },
        methods:
        {
            load() {
                let data = {};
                let url = 'product-history/cheapest-shops/' + this.id;
                if (this.url) {
                    url = this.url;
                    data.product = this.id;
                }

                return this.$http.get(url, {params: data}).then(response => {
                    this.items = response.body.data;
                })
            }
        },
        watch: {
            id: function(){
                this.load();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// CheapestShops.vue?1f688748